export const analyticsData = {
  keyMetrics: [
    { name: "Menge Asphaltmischgut", value: "1,247.5 t", trend: "+2.1%" },
    { name: "CO₂e Emissionen", value: "462 t CO2e", trend: "-1.2%" },
    { name: "Emissionsfaktor", value: "37.0 kg CO2e/t", trend: "-1.8%" }
  ],
  
  monthlyCosts: [
    { month: "Jan", material: 1200, labor: 900, equipment: 400 },
    { month: "Feb", material: 1100, labor: 950, equipment: 450 },
    { month: "Mar", material: 1300, labor: 1000, equipment: 475 },
    { month: "Apr", material: 1250, labor: 1100, equipment: 425 },
    { month: "Mai", material: 1400, labor: 1050, equipment: 500 },
    { month: "Jun", material: 1350, labor: 1150, equipment: 550 }
  ],
  
  co2Breakdown: [
    {
      category: "Asphaltmischgut",
      subCategories: [
        { name: "AC 11 D SP", plan: 450, ist: 480 },
        { name: "AC 22 B S SG", plan: 750, ist: 720 },
        { name: "AC 22 T S", plan: 300, ist: 320 }
      ],
      total: { plan: 1500, ist: 1520 }
    },
    {
      category: "Transporte",
      subCategories: [
        { name: "AC 11 D SP", plan: 300, ist: 330 },
        { name: "AC 22 B S SG", plan: 500, ist: 470 },
        { name: "AC 22 T S", plan: 200, ist: 210 }
      ],
      total: { plan: 1000, ist: 1010 }
    }
  ]
};